import { Component, Input, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { ReserveGroup } from 'src/model/reserveGroup.model';
import { ReserveGroupService } from 'src/services/reserve-group.service';
import { SetService } from 'src/services/set.service';

interface StockReport {
  schemeName: string,
  activeOutstanding: number,
  bdOutstanding: number,
  cpOutstanding: number,
  stock: number,
  stockReceived: number
}

@Component({
    selector: 'app-verify-account',
    templateUrl: './verify-account.component.html',
    styleUrls: ['./verify-account.component.scss'],
    standalone: false
})

export class VerifyAccountComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  protected sharedService = inject(SharedService);
  private restApi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  private setService = inject(SetService);
  private rgService = inject(ReserveGroupService);

  @Input() selectedCompany: number;
  @Input() endDate: Date;
  needStatusOutstanding = false;

  cashbookBalanceInput: number;
  remarkInput: string;

  actualCashbook = 0;
  disabledSubmit = false;

  unsubmittedSetCount = 0;
  unsubmittedRG: ReserveGroup[] = [];

  async ngOnInit(): Promise<void> {
    this.unsubmittedSetCount = await this.checkUnSubmittedSets();
    this.unsubmittedRG = await this.rgService.getAllReserveGroup({ valid: false, companyId: this.selectedCompany ?? undefined });
  }

  reset() {
    this.activeModal.close();
  }

  async checkUnSubmittedSets() {
    const unsubmittedSets = await this.setService.getAllTxSetsCount({ valid: false, companyId: this.selectedCompany ?? undefined });

    return (unsubmittedSets.length == 0) ? 0 : Number(unsubmittedSets[0].count);
  }

  getActualCashbook(cashbookBalance: number) {
    this.actualCashbook = cashbookBalance;
  }

  verifyInput() {
    if (this.cashbookBalanceInput == undefined) {
      this.sharedService.openAlert("Please key in Cashbook Balance", ALERT_TYPE.DANGER);
      return false;
    }

    else if (this.cashbookBalanceInput != this.actualCashbook) {
      this.sharedService.openAlert("Please key in CORRECT Cashbook Balance", ALERT_TYPE.DANGER);
      return false;
    }

    else return true
  }

  submit() {
    if (this.verifyInput() == true) {
      this.checkIn();
    }
  }

  checkIn() {
    this.disabledSubmit = true;

    //in order to get the correct result, end date need to add 1 day and minus 1 millisecond
    // 3600*1000*24 is 1 day in millisecond, then reduced by 1 millisecond
    const addADayDate = new Date(Number(this.endDate) + (3600 * 1000 * 24) - 1);

    const data = {
      "date": addADayDate.toISOString(),
      "remark": this.remarkInput
    }

    const xhr = this.restApi.postRequest(this.constructApi.getAddCompanyCheckIn(this.selectedCompany), data)
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        this.disabledSubmit = false;
        //if success , then proceed
        if (xhr.status == 200) {
          this.sharedService.openAlert("Successfully verified", ALERT_TYPE.SUCCESS);
          window.location.reload();
          this.reset();
        }
        else {
          //show error message
          this.sharedService.openAlert(JSON.parse(xhr.responseText).error, ALERT_TYPE.DANGER)
        }
      }
    }
  }
}
